import { EvidenceSessionList, QualityReportLink, useSiteMaterial } from 'features';
import { Suspense } from 'react';
import { ActionRow, Box, CardsListSkeleton, Grid, Page, Section, Typography } from 'ui';

import { ManageDataButton } from '../../components/ManageDataButton/ManageDataButton';
import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const QualityHome = () => {
  const { data } = useSiteMaterial();

  if (!data) {
    return <Typography>Material not found</Typography>;
  }

  return (
    <Page>
      <Page.Title title="Quality management" />
      <Page.Divider />
      <Grid container>
        <Grid item xs={12} md={4}>
          <Section title="Site Details">
            <Box mb={2}>
              <SiteHeader siteMaterial={data} />
            </Box>

            <ActionRow>
              <QualityReportLink siteMaterialPublicId={data.public_id} />
              <ManageDataButton />
            </ActionRow>
          </Section>
        </Grid>
        <Grid item xs={12} md={8}>
          <Section title="Sessions">
            <Suspense fallback={<CardsListSkeleton />}>
              <EvidenceSessionList siteMaterialId={data.id} defaultCollapsed />
            </Suspense>
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
